import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    tarjetasMarcas: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,

    /* Listas de selección */
    tarjetasMarcasList: [],
    tarjetasMarcasSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.tarjetasMarcas = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR_TARJETAS_MARCAS'(state) {
        state.tarjetasMarcas = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_TARJETAS_MARCAS'(state, tarjetasMarcas) {
        state.tarjetasMarcas = tarjetasMarcas;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.tarjetasMarcasList = [];
        state.tarjetasMarcasSelectList = [];
    },
    'SET_LIST'(state, params) {
        state.tarjetasMarcasList = params.tarjetasMarcasList;
        state.tarjetasMarcasSelectList = params.tarjetasMarcasSelectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getTarjetasMarcas: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETAS_MARCAS');

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }

            if (state.incluirInactivos) {
                if (state.incluirInactivos == true || state.incluirInactivos == 'true') {
                    queryString += '&incluirInactivos=true';
                }
            }

            apiAxios.get('tarjetasmarcas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TARJETAS_MARCAS', res.data);

                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })
    },

    getTarjetasMarcasList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');
            apiAxios.get('tarjetasmarcas/list')
                .then(res => {
                    var list = []
                    for(let key in res.data) {
                        const item = res.data[key]
                        list.push(item.nombre.trim())
                    } 
                    var params = {
                        tarjetasMarcasList: res.data,
                        tarjetasMarcasSelectList: list
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    tarjetasMarcasList (state) {
        return state.tarjetasMarcasList;
    },
    tarjetasMarcasSelectList (state) {
        return state.tarjetasMarcasSelectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}